import type { MarkdownShellTokens, MarkdownTableTokens, MarkdownTypographyTokens } from './primitives';

const SHARED_BREAK = 'break-words hyphens-auto [overflow-wrap:anywhere]';

export const assistantMessageMarkdownTypography: MarkdownTypographyTokens = {
  paragraph: `${SHARED_BREAK} mb-5 last:mb-0 leading-relaxed text-inherit`,
  inlineText: `${SHARED_BREAK}`,
  block: `${SHARED_BREAK}`,
  list: 'mb-5 pl-5 leading-relaxed',
  listItem: `${SHARED_BREAK} mb-2 leading-relaxed`,
};

export const userMessageMarkdownTypography: MarkdownTypographyTokens = {
  paragraph: `${SHARED_BREAK} my-0 leading-6 text-inherit`,
  inlineText: SHARED_BREAK,
  block: SHARED_BREAK,
  list: 'my-0 pl-5 leading-6',
  listItem: `${SHARED_BREAK} my-0 leading-6`,
};

export const assistantMessageMarkdownShell: MarkdownShellTokens = {
  wrapper: 'w-full min-w-0 [&>*]:max-h-none [&>*]:overflow-visible',
  prose: 'prose dark:prose-invert prose-sm max-w-none text-inherit [&_p]:mt-0 [&_ul]:mt-0 [&_ol]:mt-0 [&_li]:mt-0',
};

export const userMessageMarkdownShell: MarkdownShellTokens = {
  wrapper: 'w-full min-w-0',
  prose: 'prose dark:prose-invert prose-sm max-w-none text-inherit',
};

export const assistantMessageMarkdownTable: MarkdownTableTokens = {
  wrapper: 'my-4 w-full max-w-full min-w-0',
  hint: 'md:hidden flex items-center text-xs text-neutral-400 mb-1',
  scroller: 'w-full max-w-full min-w-0 overflow-x-auto rounded-md border border-neutral-200 dark:border-neutral-700',
  table: 'w-full table-auto divide-y divide-neutral-200 dark:divide-neutral-700 text-sm',
  thead: 'bg-neutral-50 dark:bg-neutral-800',
  tbody: 'divide-y divide-neutral-200 dark:divide-neutral-700 bg-transparent',
  row: 'transition-colors hover:bg-neutral-50/50 dark:hover:bg-neutral-800/50',
  th: 'px-4 py-3 text-left font-semibold text-neutral-900 dark:text-neutral-100 whitespace-nowrap',
  td: 'px-4 py-3 text-neutral-700 dark:text-neutral-300 align-top whitespace-normal',
};

export const userMessageMarkdownTable: MarkdownTableTokens = {
  wrapper: 'my-4 w-full max-w-full min-w-0',
  hint: 'md:hidden flex items-center text-xs text-neutral-400 mb-1 sticky left-0',
  scroller: 'w-full max-w-full min-w-0 overflow-x-auto rounded-md border border-neutral-600',
  table: 'w-full table-auto divide-y divide-neutral-600 text-sm',
  thead: 'bg-neutral-700',
  tbody: 'divide-y divide-neutral-600 bg-transparent',
  row: 'transition-colors hover:bg-neutral-700/50',
  th: 'px-4 py-3 text-left font-semibold text-white whitespace-nowrap',
  td: 'px-4 py-3 text-neutral-200 align-top whitespace-normal',
};

export const ideaCardMarkdownTable: MarkdownTableTokens = {
  wrapper: 'my-2 w-full max-w-full min-w-0',
  hint: 'md:hidden flex items-center text-xs text-neutral-400 mb-1',
  scroller: 'w-full max-w-full min-w-0 overflow-x-auto rounded-md border border-neutral-200 dark:border-neutral-700',
  table: 'w-full table-auto divide-y divide-neutral-200 dark:divide-neutral-700 text-sm',
  thead: 'bg-neutral-50 dark:bg-neutral-800',
  tbody: 'divide-y divide-neutral-200 dark:divide-neutral-700 bg-transparent',
  row: 'transition-colors hover:bg-neutral-50/50 dark:hover:bg-neutral-800/50',
  th: 'px-3 py-2 text-left font-semibold text-neutral-900 dark:text-neutral-100 whitespace-nowrap',
  td: 'px-3 py-2 text-neutral-700 dark:text-neutral-300 align-top whitespace-normal',
};
